//@ts-nocheck
import {Column} from 'react-table'
import {EnterprisesTypeName} from './EnterprisesTypeName'
import {EnterprisesTypeDescCell} from './EnterprisesTypeDescCell'
// import {EnterprisesTypeLastLoginCell} from './EnterprisesTypeLastLoginCell'
// import {EnterprisesTypeTwoStepsCell} from './EnterprisesTypeTwoStepsCell'
import {EnterprisesTypeActionsCell} from './EnterprisesTypeActionsCell'
//import {EnterprisesTypeSelectionCell} from './EnterprisesTypeSelectionCell'
import {EnterprisesTypeCustomHeader} from './EnterprisesTypeCustomHeader'
//import {EnterprisesTypeSelectionHeader} from './EnterprisesTypeSelectionHeader'
import {EnterprisesType} from '../../core/_models'

const EnterprisesTypeColumns: ReadonlyArray<Column<EnterprisesType>> = [
  {
    Header: (props) => (
      <EnterprisesTypeCustomHeader
        tableProps={props}
        title='COMMON.INPUT_NAME'
        className='fs-8 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'name',
    Cell: ({...props}) => <EnterprisesTypeName EnterprisesType={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <EnterprisesTypeCustomHeader
        tableProps={props}
        title='COMMON.DESCRIPTION'
        className='fs-8 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'description',
    Cell: ({...props}) => <EnterprisesTypeDescCell EnterprisesType={props.data[props.row.index]} />,
  },

  {
    Header: (props) => (
      <EnterprisesTypeCustomHeader
        tableProps={props}
        title='MENU.ACTIONS'
        className='text-center fs-8 min-w-100px'
      />
    ),
    id: 'actions',
    Cell: ({...props}) => <EnterprisesTypeActionsCell data={props.data[props.row.index]} />,
  },
]

export {EnterprisesTypeColumns}
